import { Link } from "react-router-dom";
import { MAIN_NAV, MORE_GROUPS, ABOUT } from "@/components/site/nav";
import { SocialLinks } from "@/components/site/SocialLinks";

const FooterCol = ({ title, testId, children }) => (
  <div data-testid={testId}>
    <p className="text-[11px] uppercase tracking-[0.25em] text-primary font-bold mb-4">{title}</p>
    <ul className="space-y-2">{children}</ul>
  </div>
);

const FooterLink = ({ to, testId, children }) => (
  <li>
    <Link to={to} className="text-zinc-400 hover:text-white transition-colors" data-testid={testId}>{children}</Link>
  </li>
);

export const Footer = () => (
  <footer className="bg-black border-t border-white/10 pb-20" data-testid="site-footer">
    <div className="max-w-[1600px] mx-auto px-5 md:px-10 pt-16">
      <div className="grid grid-cols-2 lg:grid-cols-6 gap-10">
        <div className="col-span-2 lg:col-span-1" data-testid="footer-brand">
          <Link to="/" data-testid="footer-logo-link">
            <img src="/brand/logo.png" alt="LEGROSTASDEZIK" className="h-10 w-auto select-none" />
          </Link>
          <p className="text-zinc-400 text-sm mt-4 max-w-[240px]">LGTDZ — le média, la radio.</p>
          <SocialLinks />
        </div>
        <FooterCol title="L'essentiel" testId="footer-col-main">
          {MAIN_NAV.map((n) => <FooterLink key={n.to} to={n.to} testId={`footer-nav-${n.key}`}>{n.label}</FooterLink>)}
        </FooterCol>
        {MORE_GROUPS.map((g) => (
          <FooterCol key={g.key} title={g.title} testId={`footer-col-${g.key}`}>
            {g.links.map((l) => <FooterLink key={l.to} to={l.to} testId={`footer-nav-${l.key}`}>{l.label}</FooterLink>)}
          </FooterCol>
        ))}
        <FooterCol title="À propos" testId="footer-col-apropos">
          {ABOUT.map((l) => <FooterLink key={l.to} to={l.to} testId={`footer-legal-${l.key}`}>{l.label}</FooterLink>)}
        </FooterCol>
      </div>
      <p className="text-xs uppercase tracking-[0.2em] font-bold text-zinc-500 py-10 flex flex-wrap justify-between gap-4">
        <span>Alpha Diallo — Tous droits réservés</span>
        <Link to="/admin/login" className="hover:text-white transition-colors" data-testid="footer-admin-link">Espace admin</Link>
      </p>
    </div>
  </footer>
);
